import {
  Select,
  SelectItem,
  type SelectProps,
  Tooltip,
} from "@prismicio/editor-ui"

import type { BillingPeriod } from "../../app/services/billing"
import { formatBillingPeriod } from "../billing/billingUtils"

interface BillingPeriodSelectProps {
  billingPeriods: BillingPeriod[]
  selectedBillingPeriod: BillingPeriod
  onSelectedBillingPeriodChange: (selectedBillingPeriod: BillingPeriod) => void
}

export function BillingPeriodSelect(props: BillingPeriodSelectProps) {
  const {
    billingPeriods,
    selectedBillingPeriod,
    onSelectedBillingPeriodChange,
  } = props

  const disabled = billingPeriods.length === 1

  return (
    <Tooltip
      content="Previous billing periods coming soon"
      visible={disabled}
      sideOffset={4}
      stableMount
    >
      <BillingPeriodSelectTemplate
        value={getBillingPeriodSelectValue(selectedBillingPeriod)}
        onValueChange={(value) => {
          const selectedBillingPeriod = billingPeriods.find(
            (billingPeriod) =>
              getBillingPeriodSelectValue(billingPeriod) === value,
          )
          if (selectedBillingPeriod === undefined) return
          onSelectedBillingPeriodChange(selectedBillingPeriod)
        }}
        disabled={disabled}
      >
        {billingPeriods.map((billingPeriod) => {
          const value = getBillingPeriodSelectValue(billingPeriod)
          return (
            <SelectItem key={value} value={value}>
              {formatBillingPeriod(billingPeriod)}
            </SelectItem>
          )
        })}
      </BillingPeriodSelectTemplate>
    </Tooltip>
  )
}

type BillingPeriodSelectTemplateProps = Pick<
  SelectProps,
  "children" | "disabled" | "onValueChange" | "value"
>

function BillingPeriodSelectTemplate(props: BillingPeriodSelectTemplateProps) {
  return (
    <Select
      {...props}
      boldTriggerText
      color="grey"
      placeholder="Select a billing period"
    />
  )
}

export function BillingPeriodSelectSkeleton() {
  return <BillingPeriodSelectTemplate disabled />
}

function getBillingPeriodSelectValue(billingPeriod: BillingPeriod): string {
  return `${billingPeriod.startDate.getTime()}-${billingPeriod.endDate.getTime()}`
}
